import React from "react";
import PropTypes from "prop-types";
import { FiFilter } from "react-icons/fi";
import { ReactComponent as ClearSvg } from "../../../../assets/icons/clear.svg";
import clsx from "clsx";
import styles from "./styles.module.scss";

const VARIANT_CONFIG = {
  filter: {
    icon: <FiFilter />,
    label: "Filtrar",
  },
  clear: {
    icon: <ClearSvg />,
    label: "Limpar filtros",
  },
};

const FilterButton = ({ onClick, variant = "filter", ...props}) => {
  const { icon, label } = VARIANT_CONFIG[variant];

  return (
    <button
      type="button"
      className={clsx(styles.filterBtn, {
        [styles.filterClearBtn]: variant === "clear",
      })}
      onClick={onClick}
      {...props}
    >
      {icon}
      <span>{label}</span>
    </button>
  );
};

FilterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["filter", "clear"]),
};

export default FilterButton;
